import {
  compose,
  withPropsOnChange,
  withState,
  withHandlers,
  mapProps,
} from 'recompose';
import * as R from 'ramda';

import { SearchFilterCondition as SFCC } from './SearchFilterCondition';

const setDefaultState = R.pipe(
  R.prop('value'),
  R.tryCatch(JSON.parse, () => {}),
  R.merge({ condition: 'EQ' }),
);

const enhance = compose(
  withState('state', 'setState', setDefaultState),
  withPropsOnChange(['value'], ({ setState, ...rest }) => {
    setState(setDefaultState(rest));

    return {};
  }),
  withHandlers({
    onChange: ({ state, setState, onChange }) => (name, value) => {
      const values = {
        ...state,
        [name]: value,
      };

      if (onChange && R.length(R.values(values)) === 3) {
        onChange(R.tryCatch(JSON.stringify, () => null)(values));
      }

      setState(values);
    },
  }),
  mapProps(({ state, setState, ...rest }) => ({
    ...rest,
    ...state,
  })),
);

export const SearchFilterCondition = enhance(SFCC);
